export enum GameStateEnum{
    uninitialized,
    started,
    won,
    gameover
}